import { Form, Input, Grid, Field, Select } from "@alifd/next";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const regexp = new RegExp(/^[a-zA-Z][0-9a-zA-Z_]{0,49}$/);
const Option = Select.Option;
const AddDepType = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, options, ...otherProps } = props;
    const data = { Active: true, Id: "", Name: "", RoleId: "" };
    const [dataSource, setDataSource] = useState({});
    const [ops, setOps] = useState<any>([]);
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        fieldRef.current.reset();
        fieldRef.current.setValues(data)
        setOps(options);
    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);
    return (
        <Form field={fieldRef.current} className="bef-custom-dep">
            <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item required label="级别编号" className="custom-form-control" name="Id" pattern={regexp} patternMessage={'编号必须以字母开始，可以由字母、数字、下划线组成；且在50字符以内！'}>
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item required label="级别名" name="Name" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});
export default AddDepType;